module.exports = __webpack_public_path__ + "static/media/sign-out.372420da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/sign-out.svg
// module id = 843
// module chunks = 21